export default __webpack_public_path__ + "static/media/laptopMan.0143dfd6.svg";